import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Icon from '@atoms/Icon/Icon';
import Text from '@atoms/Text/Text';
import Title from '@atoms/Title/Title';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from '@material-ui/core';
import { FiPlus } from 'react-icons/fi';
import { IoMdClose } from 'react-icons/io';
import Link from '@components/Link';

type ListData = {
    title: string;
    list: Array<{ title?: string; url?: string; isLink?: boolean }>;
};

interface Props {
    data: ListData;
    tab: string | null;
    setTab: (tab: string | null) => void;
}

const HeaderNavSubMenuListMobile: React.FC<Props> = ({ data, tab, setTab }) => {
    const isActive = tab === data.title;

    const { t } = useTranslation();

    const onChange = () => {
        setTab(tab === data.title ? null : data.title);
    };

    return (
        <Accordion expanded={isActive} onChange={onChange}>
            <AccordionSummary
                expandIcon={
                    <Icon
                        icon={isActive ? <IoMdClose /> : <FiPlus />}
                        size="xs"
                        theme="white"
                    />
                }
            >
                <Text size="m" theme="white">
                    {t(data.title)}
                </Text>
            </AccordionSummary>
            <AccordionDetails>
                {data.list.map((i) => (
                    <div key={i.url}>
                        {i.customLink ? (
                            i.customLink
                        ) : (
                            <>
                                {i.title && (
                                    <Title size="ml" theme="white">
                                        <Link
                                            to={i.url}
                                            className={
                                                i.isLink ? 'is-link' : ''
                                            }
                                        >
                                            {t(i.title)}
                                        </Link>
                                    </Title>
                                )}
                            </>
                        )}
                    </div>
                ))}
            </AccordionDetails>
        </Accordion>
    );
};

export default HeaderNavSubMenuListMobile;
